const calculateDefaultXSize = (minX: number, maxX: number): number => {
  const result = minX + (maxX - minX) / 2;
  return Number(result.toFixed(1));
};

export default calculateDefaultXSize;
